import React from 'react';
import { Grid, Typography, Paper, Box } from '@mui/material';
import CodeIcon from '@mui/icons-material/Code';
import InsightsIcon from '@mui/icons-material/Insights';
import DevicesIcon from '@mui/icons-material/Devices';

const features = [
  { icon: <CodeIcon fontSize="large" />, title: "Custom Development", desc: "Tailored software to match your business needs." },
  { icon: <InsightsIcon fontSize="large" />, title: "Data-Driven Insights", desc: "Make smarter decisions with real-time analytics." },
  { icon: <DevicesIcon fontSize="large" />, title: "Cross-Platform", desc: "Access your tools from any device, anywhere." },
];

function Features() {
  return (
    <Box my={6}>
      <Typography variant="h4" align="center" gutterBottom>
        Why Choose Wondersoft?
      </Typography>
      <Grid container spacing={4} justifyContent="center">
        {features.map((f, i) => (
          <Grid item xs={12} md={4} key={i}>
            <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
              {f.icon}
              <Typography variant="h6" gutterBottom>{f.title}</Typography>
              <Typography color="text.secondary">{f.desc}</Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default Features;
